import React, { useEffect, useState } from 'react'
import { Link, useParams, useLocation } from 'react-router-dom'
import config from '../coreFIles/config'
import new_image from '../Assets/new.gif'
import toast, { Toaster } from 'react-hot-toast';
import { getsidebarMenuAction, getbannerAdsAction, UpgradeAccountAction, memberloginwithfacebookAction, logBannerClickAction, catDetailsAction, getadDataFromSidesAction } from '../Action/action';
import Cookies from 'js-cookie'
import FacebookLogin from '@greatsumini/react-facebook-login';
const ageVerified = (!Cookies.get('ageVerified')) ? false : Cookies.get('ageVerified');

const Leftsidebar = () => {
    const { id } = useParams();
    const location = useLocation();
	
	// Style state for reactive styling
	const [Style, setStyle] = useState([]);
	
	useEffect(() => {
		const updateStyles = () => {
			const storedStyle = Cookies.get('domainstyle');
			if (storedStyle) {
				try {
					setStyle(JSON.parse(storedStyle));
				} catch (error) {
					console.error('Error parsing style cookie:', error);
					setStyle([]);
				}
			} else {
				setStyle([]);
			}
		};
		
		updateStyles();
		const interval = setInterval(updateStyles, 500);
		return () => clearInterval(interval);
	}, []);
	
	// Style values
	const getStyleValue = (key) => {
		if (Style && Array.isArray(Style) && Style.length > 0 && Style[0] && Style[0][key]) {
			return `#${Style[0][key]}`;
		}
		return '';
	};
	const headerButtonColor = getStyleValue('header_buttoncolor');
	const headerMenuColor = getStyleValue('header_menu');
	const headerMenuHoverColor = getStyleValue('header_menu_hover');
	const header_search_text = getStyleValue('header_search_text');
	// style end
	const getLoginData = () => {
		try {
			const cookieData = Cookies.get('loginSuccessMember');
			return cookieData ? JSON.parse(cookieData) : [];
		} catch (error) {
			console.error('Error parsing loginSuccessMember cookie:', error);
			return [];
		}
	};
	const loginData = getLoginData();
	const [sidebarMenu, setsidebarMenu] = useState({});
	const [bannerAds, setbannerAds] = useState({});
    const [facebooklogin, setfacebooklogin] = useState("0")
    const [parentCatId, setParentCatId] = useState(null)
    const [adParentCatId, setAdParentCatId] = useState(null)
    const [adCategoryId, setAdCategoryId] = useState(null)
	useEffect(() => {
		getsidebarMenu();
		getbannerAds();
	}, [])
    useEffect(() => {
        // Try to fetch parent category if id is present
        if (id) {
            (async () => {
                try {
                    // Check if we're on ad details page
                    const isAdDetailsPage = location.pathname.includes('/ad/');
                    if (isAdDetailsPage) {
                        // On ad details page, get parent_cat_id from ad data
                        const adRes = await getadDataFromSidesAction({ id: id, any: '' });
                        if (adRes && adRes.success && adRes.data && typeof adRes.data.parent_cat_id !== 'undefined') {
                            setAdParentCatId(parseInt(adRes.data.parent_cat_id));
                            setParentCatId(parseInt(adRes.data.parent_cat_id));
                            if (typeof adRes.data.category_id !== 'undefined') {
                                setAdCategoryId(String(adRes.data.category_id));
                            } else {
                                setAdCategoryId(null);
                            }
                        } else {
                            setAdParentCatId(null);
                            setParentCatId(null);
                            setAdCategoryId(null);
                        }
                    } else {
                        // On category page, get parent_id from category data
                        const res = await catDetailsAction({ catId: id, any: 'action' });
                        if (res && res.success && res.data && typeof res.data.parent_id !== 'undefined') {
                            setParentCatId(parseInt(res.data.parent_id));
                        } else {
                            // In view-all pages, id is already the parent category id
                            const numericId = parseInt(id);
                            setParentCatId(!isNaN(numericId) ? numericId : null);
                        }
                        setAdCategoryId(null);
                        setAdParentCatId(null);
                    }
                } catch (e) {
                    setParentCatId(null);
                    setAdParentCatId(null);
                    setAdCategoryId(null);
                }
            })();
        } else {
            setParentCatId(null);
            setAdParentCatId(null);
            setAdCategoryId(null);
        }
    }, [id, location.pathname])
	useEffect(() => {
		let action = loginData.action
		if (action == "fbLogin") {
			setfacebooklogin("1")
		}
	}, [])

	const getsidebarMenu = async () => {
		let res = await getsidebarMenuAction({ keyword: 'footer' });
		if (res.success) {
			setsidebarMenu(res.data);
		}
	};
	
	const handleBannerClick = async (row, evt) => {
		// Log banner click on mouse click
		try {
			let domainId = 0;
			try {
				const cookieData = Cookies.get('domain_id');
				if (cookieData) {
					const parsed = JSON.parse(cookieData);
					domainId = parsed?.domain_id || 0;
				}
			} catch (e) {
				console.error('Error parsing domain_id cookie:', e);
			}
			await logBannerClickAction({ ad_id: row.ad_id, type: 1, metrocity: domainId });
		} catch (e) { /* noop */ }
	};

	const handleBannerKeyDown = async (row, evt) => {
		// Log banner click on keyboard navigation (Enter or Space) - let browser handle navigation naturally
		if (evt.key === 'Enter' || evt.key === ' ') {
			try {
				let domainId = 0;
				try {
					const cookieData = Cookies.get('domain_id');
					if (cookieData) {
						const parsed = JSON.parse(cookieData);
						domainId = parsed?.domain_id || 0;
					}
				} catch (e) {
					console.error('Error parsing domain_id cookie:', e);
				}
				await logBannerClickAction({ ad_id: row.ad_id, type: 1, metrocity: domainId });
				// Don't prevent default - let browser navigate naturally via href with target="_blank"
			} catch (e) { /* noop */ }
		}
	};

	const getbannerAds = async () => {
		let res = await getbannerAdsAction({ adColumn: 'L' });
		if (res.success) {
			setbannerAds(res.data);
		}
	};

	const handleContentUrl = (id) => {
		var pagenewUrl = '';
		if (id == 1) {
			pagenewUrl = config.baseUrl + 'about'
		}
		else if (id == 2) {
			pagenewUrl = config.baseUrl + 'advertise-with-us'
		}
		else if (id == 3) {
			pagenewUrl = config.baseUrl + 'help'
		}
		else if (id == 5) {
			pagenewUrl = config.baseUrl + 'terms-and-conditions'
		}
		else if (id == 6) {
			pagenewUrl = config.baseUrl + 'privacy-policy'
		}
		window.location.href = `${pagenewUrl}`;
	};
	const formatDate = (str) => {
		const date = new Date(str);
		const mnth = ("0" + (date.getMonth() + 1)).slice(-2);
		const day = ("0" + date.getDate()).slice(-2);
		return [date.getFullYear(), mnth, day].join("-");
	};

	const adddaysToDate = (days) => {
		const cdate = new Date();
		const result = cdate.setDate(cdate.getDate() + days);
		return formatDate(result);
	};
	const upgrademembership = async () => {

		if (loginData) {
			const fromDate = formatDate(new Date());
			const res = await UpgradeAccountAction({ memberid: loginData.id, current_date: fromDate })
			if (res.success) {
				toast.success(res.msg);
				// setInterval(() => {
				//     window.location.href=`${config.baseUrl}`
				// }, 2000);
			}


		}

	}
	// for facebook login 
	const responseFacebook = async (response) => {
		let res = await memberloginwithfacebookAction(response)
		if (res.success) {
			toast.success(res.msg)
			Cookies.set('loginSuccessMember', JSON.stringify(res.data));
			setTimeout(() => {
				window.location.href = `${config.baseUrl}`;
			}, 1200);
		}
		else {
			toast.error(res.msg)
		}
	}
	const handleLogout = () => {
		setfacebooklogin("0")
		console.log(facebooklogin)
		Cookies.remove("loginSuccessMember");
		window.location.href = config.baseUrl;
	};
	return (
		<>
			<Toaster />
			<div className="section-member">
				<div className="btnpost">
					{!loginData || loginData == '' ?
						<Link to={config.baseUrl + 'login'} style={{ background: headerMenuColor }}><span><img src={config.baseUrl + "img/ads.png"} alt='ads' /></span>Post Your Ad</Link>
						:
						<Link to={config.baseUrl + 'addad'} style={{ background: headerMenuColor }}><span><img src={config.baseUrl + "img/ads.png"} alt='ads' /></span>Post Your Ad</Link>
					}
				</div>
				{!loginData || loginData == '' ?
					<div className="btnpost">
						<Link to={config.baseUrl + 'login'} style={{ background: headerMenuColor }}><span><i className="fa-solid fa-arrow-right-to-bracket"></i></span>Member Login</Link>
					</div>
					:
					<div className="btnpost">
						<Link to={config.baseUrl + 'manage-ads'} style={{ background: headerMenuColor }}><span><i className="fa-solid fa-arrow-right-to-bracket"></i></span>Manage Ads</Link>
						<Link to={config.baseUrl + 'SearchHistory'} style={{ background: headerMenuColor }}><span><i className="fa-solid fa-search"></i></span>Search History</Link>
						<Link to={config.baseUrl + 'MarkfavouriteAd'} style={{ background: headerMenuColor }}><span><i className="fa-solid fa-heart"></i></span>Favourite Ads</Link>
					</div>
				}

				<div className="domorecor-logo  d-none">
					<img src={config.baseUrl + "img/domorecor.png"} alt='do more' />
				</div>
				<div  className="btnpost d-none" >
					{
						facebooklogin === "0" ?
							<FacebookLogin
							appId="986705326547259"
							autoLoad={false}
							fields="name,email,picture"
							callback={responseFacebook}
							render={renderProps => (
								<button
								type="button"
								className="btnFacebook"
								onClick={renderProps.onClick}
								>
								<i className="fa-brands fa-facebook-f" style={{ marginRight: 8 }} />
								Login with Facebook
								</button>
							)}
							/>
							: ""}
					{
						facebooklogin === "1" ?
							<Link to="" onClick={handleLogout} style={{background:headerButtonColor}}><span ><i className="fa-brands fa-facebook-f"></i></span>Logout</Link> :
							""
					}

				</div>
				<div className="about-section">
					<ul>
						<h4 style={{ background: headerMenuColor }}>MENU</h4>
						{sidebarMenu.length > 0 ?
							sidebarMenu.map((row) => 
								(
									<li><Link to="javascript:;" onClick={() => handleContentUrl(row.content_id)}>{row.title}</Link></li>
							))
							: ''
							}
						{!loginData || loginData == '' ?
							(
								<li><Link to={config.baseUrl + 'vipmembership'}>
									VIP MEMBERSHIP</Link><img src={new_image} style={{ marginLeft: "15px" }} alt="Connection error" /></li>
							)
							:
							(
								<li><Link to={config.baseUrl + 'vipmembership'}>VIP MEMBERSHIP</Link><img src={new_image} style={{ marginLeft: "15px" }} alt="Connection error" /></li>
							)
						}
						<li><Link to={config.baseUrl + 'sharewithfriend'}>TELL A FRIEND</Link></li>
						<li><Link to={config.baseUrl + 'contact-us'}>CONTACT US</Link></li>

						{/* <li><Link to="">ABOUT US</Link></li>
						<li><Link to="">ADVERTISE WITH US</Link></li>
						<li><Link to="">VIP MEMBERSHIP</Link></li>
						<li><Link to="">TELL A FRIEND</Link></li>
						<li><Link to="">HELP</Link></li>
						<li><Link to="">CONTACT US</Link></li> */}
					</ul>
				</div>
				
				<div className="towblock">
					{bannerAds.length > 0 ? (
                        bannerAds.map((row, index) => {
                            const ad_pages = row?.ad_pages || '';
                            const pagesArray = ad_pages.split(',').filter(Boolean);
                            const includesOne = pagesArray.includes('1');
                            const isVerified = (ageVerified === 'true' || ageVerified === true);
                            const allowSensitive = isVerified && ((String(id) === '1') || (parentCatId === 1) || (adParentCatId === 1));
                            // Determine page context
                            const pathname = location.pathname || '';
                            const isHome = pathname === '/' || pathname === '';
                            const isGeneralPage = ['about', 'contact-us', 'rssfeeds', 'sharewithfriend', 'vipmembership'].some(p => pathname.includes(`/${p}`));
                            const isAdListingPage = pathname.startsWith('/cat');
                            const isAdDetailPage = pathname.startsWith('/ad/');
                            // Side match: B for both, or explicit side L
                            const adColumn = (row.ad_column || '').toUpperCase();
                            const sideMatches = adColumn === 'B' || adColumn === 'L' || adColumn === '';
                            // For ad details/listing pages, match ad_pages with category id or parent id
                            const categoryMatch = (adCategoryId && pagesArray.includes(String(adCategoryId))) || (parentCatId && pagesArray.includes(String(parentCatId)));
                            // Base visibility by page type and flags
                            let baseVisible = false;
                            if (isHome) {
                                baseVisible = (row.onhome === 1) || (row.ad_allpages === 1);
                            } else if (isGeneralPage) {
                                baseVisible = (row.ad_genpages === 1) || (row.ad_allpages === 1);
                            } else if (isAdListingPage) {
                                baseVisible = (row.ad_allpages === 1) || categoryMatch;
                            } else if (isAdDetailPage) {
                                baseVisible = (row.ad_allpages === 1) || categoryMatch;
                            } else {
                                // Other pages: default to ad_allpages only
                                baseVisible = (row.ad_allpages === 1);
                            }

                            let shouldRender = false;
                            if (!isVerified) {
                                // Non-verified users: only generic page (46) banners and not personals (1)
                                shouldRender = pagesArray.includes('46') && !includesOne && row.ad_type === 'img' && baseVisible && sideMatches;
                            } else {
                                // For listing/detail pages, enforce personals vs non-personals split
                                if (isAdListingPage || isAdDetailPage) {
                                    // Check both parentCatId and adParentCatId for personals context
                                    const personalsContext = (parseInt(parentCatId) === 1) || (parseInt(adParentCatId) === 1);
                                    if (personalsContext) {
                                        // Show only personals banners (must include '1' in ad_pages)
                                        shouldRender = includesOne && row.ad_type === 'img' && baseVisible && sideMatches;
                                    } else {
                                        // Show only non-personal banners (must NOT include '1' in ad_pages)
                                        shouldRender = !includesOne && row.ad_type === 'img' && baseVisible && sideMatches;
                                    }
                                } else {
                                    // Other pages keep previous logic
                                    if (includesOne && allowSensitive) {
                                        shouldRender = row.ad_type === 'img' && baseVisible && sideMatches;
                                    } else if (!includesOne) {
                                        shouldRender = row.ad_type === 'img' && baseVisible && sideMatches;
                                    } else {
                                        shouldRender = false;
                                    }
                                }
                            }

                            if (!shouldRender) return null;

                            return (
                                <div className="heroimg" key={index}>
                                    <a 
                                        href={row.ad_url || '#'}
                                        onClick={(e) => handleBannerClick(row, e)}                                        
                                        title={row.ad_title || 'Banner ad'}
                                        style={{ cursor: 'pointer', display: 'block' }}
                                        target={row.ad_url ? '_blank' : undefined}
                                        rel={row.ad_url ? 'noopener noreferrer' : undefined}
                                        tabIndex={0}
                                    >
                                        <img src={config.bannersUrl + row.ad_file} alt={row.ad_title || 'Banner ad'} style={{ width: '100%', height: 'auto', maxWidth: '100%', pointerEvents: 'none' }} />
                                    </a>
                                </div>
                            );
                        })
                    ) : ''}
                </div>
			</div>
		</>
	)
}

export default Leftsidebar;
